import React from "react";
import icon from "@/Assets/teenyicons_file-tick-solid.svg";
import { useNavigate } from "react-router-dom";

export default function PricingCards() {
  const navigate = useNavigate();
  return (
    <div className="w-full bg-[#f0f2f5] py-16 flex justify-center">
      {/* ✅ Use your global container */}
      <div className="container-width relative z-10">
        <div className="flex gap-2 flex-col sm:flex-row items-stretch sm:items-end">
          {/* LEFT CARD */}
          <div className="flex-1 bg-white rounded-[18px] border border-[#e5e7eb] shadow-sm p-7 flex flex-col">
            <span className="inline-flex items-center text-[10.5px] font-semibold tracking-[0.09em] uppercase px-3 py-[5px] rounded-full mb-6 w-fit bg-[#f1f3f5] text-[#6b7280] border border-[#e5e7eb]">
              Standard Billing
            </span>

            <h2 className="text-[38px] font-bold text-[#111827] leading-[1.12] tracking-[-0.022em] mb-3">
              Pay as you go
            </h2>

            <p className="text-[14px] text-[#6b7280] leading-[1.65] mb-3">
              Start for free with $200 in credits. Pay-as-you-go afterward, with
              simple per-block pricing and no commitments.
            </p>

            <a
              href="/"
              className="text-[13.5px] font-medium text-[#2563eb] underline underline-offset-2 mb-7 cursor-pointer"
            >
              Learn more
            </a>

            <button
              onClick={() => navigate("/contact-us")}
              className="w-full py-[15px] border border-[#e5e7eb] rounded-[4px] text-[#2563eb] text-[14.5px] font-semibold hover:bg-blue-50 transition"
            >
              Get started for free
            </button>
            <p className="text-[12.5px] text-[#9ca3af] text-center pt-1">
              Get started instantly with free credits
            </p>
          </div>

          {/* RIGHT CARD */}
          <div className=" flex-1 bg-white rounded-[18px] border border-[#e5e7eb] shadow-sm p-7 flex flex-col">
            <span className="inline-flex items-center text-[10.5px] font-semibold tracking-[0.09em] uppercase px-3 py-[5px] rounded-full mb-6 w-fit bg-[#e0f7ef] text-[#0d9668]">
              Volume Pricing Tiers
            </span>

            <h2 className="text-[38px] font-bold text-[#111827] leading-[1.12] tracking-[-0.022em] mb-3">
              Credits Accelerate
            </h2>

            <p className="text-[14px] text-[#6b7280] leading-[1.65] mb-3">
              Scale your workflows with volume-based pricing and unlock the full
              potential of our premium features. Talk to our Sales team and get
              higher processing value with volume discounts.
            </p>

            <a
              href="/"
              className="text-[13.5px] font-medium text-[#2563eb] underline underline-offset-2 mb-6 cursor-pointer"
            >
              Learn more
            </a>

            {/* FEATURES */}
            <div className="grid grid-cols-2 gap-y-3 gap-x-2 mb-6">
              {[
                "Volume-based cost optimisation",
                "Team-wide credit sharing",
                "Unlock premium AI blocks",
                "AI Reporting and Analytics",
              ].map((text, i) => (
                <div
                  key={i}
                  className="flex items-center gap-2 text-[13.5px] text-[#374151] leading-[1.3]"
                >
                  <div className="w-5 h-5 rounded-[5px] bg-[#d1fae5] flex items-center justify-center shrink-0">
                    {/* <div className="w-2 h-2 bg-[#059669] rounded-sm" /> */}
                    <img src={icon} />
                  </div>
                  {text}
                </div>
              ))}
            </div>

            <button
              onClick={() => navigate("/contact-us")}
              className="w-full btn-primary py-4 rounded-xl bg-indigo-600 text-white text-[15px] font-semibold mb-2 hover:btn-secondary transition"
            >
              Talk to Sales
            </button>

            <p className="text-[12.5px] text-[#9ca3af] text-center">
              Get a demo and custom quote based on your volume needs
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
